module.exports = __webpack_public_path__ + "img/pr-27.936e9086.png";